import { Invoice } from '../../../modals/invoice.model';

export interface InvoiceSelectionConfig {
  /** Enable server-side full database search */
  enableFullSearch?: boolean;
  
  /** Enable client-side quick search on loaded invoices */
  enableQuickSearch?: boolean;
  
  /** Default search mode when dialog opens */
  defaultSearchMode?: 'full' | 'quick';
  
  /** Minimum characters before triggering search */
  minSearchLength?: number;
  
  /** Debounce time for search input (ms) */
  debounceTime?: number;
  
  /** Auto-focus search input when dialog opens */
  autoFocus?: boolean;
  
  /** Dialog width (CSS value) */
  dialogWidth?: string;
  
  /** Maximum height for table container */
  tableMaxHeight?: string;
}


export const DEFAULT_INVOICE_SELECTION_CONFIG: InvoiceSelectionConfig = {
  enableFullSearch: true,
  enableQuickSearch: true,
  defaultSearchMode: 'full',
  minSearchLength: 2,
  debounceTime: 300,
  autoFocus: true,
  dialogWidth: '70vw',
  tableMaxHeight: '400px'
};


/**
 * Invoice with formatted label for autocomplete display
 */
export interface InvoiceSuggestion extends Invoice {
  formattedLabel?: string;
}

/**
 * Event emitted when invoice is selected
 */
export interface InvoiceSelectionEvent {
  /** Selected invoice data */
  invoice: Invoice;
  
  /** How invoice was selected */
  selectionMethod: 'row-click' | 'autocomplete' | 'keyboard';
  
  /** Timestamp of selection */
  timestamp: Date;
}

/**
 * Search mode type
 */
export type SearchMode = 'full' | 'quick';

/**
 * Search state for component
 */
export interface InvoiceSearchState {
  mode: SearchMode;
  query: string;
  isLoading: boolean;
  hasError: boolean;
  errorMessage?: string;
}

